'use strict';

angular.module('far.admin')
    .controller('RubricController', function (Rubric, form, softdeleteable) {
        (function init() {
            softdeleteable.setModel(Rubric);
        })();

        var vm = {
            formRubric: form('form'),
            form: {},
            progress: false,
            constructor: function (rubric) {
                vm.progress = true;
                vm.form = Rubric.get(rubric, function() {
                    vm.progress = false;
                });
            },
            submit: function() {
                vm.progress = true;
                vm.form.save()
                    .then(function (response) {
                        window.location.href = '/admin/blog/rubric/' + response.data.id;
                    }, function errorCallback(response) {
                        response = http.authenticationListener(response);
                        vm.errors = [];

                        if (angular.isDefined(response.data.errors) ) {
                            for ( var key in response.data.errors ) {
                                vm.errors.push(response.data.errors[key]);
                            }
                        } else {
                            showModalMessage('Ошибка на сервере. Попробуйте позже.');
                        }

                        vm.submitted = false;
                        vm.progress = false;
                    })
            }
        };

        vm.formRubric
            .addField('name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Название',
                    class: 'form__item width-130'
                }
            })
            .addField('title', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Title',
                    class: 'form__item width-130'
                }
            })
            .addField('description', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Description',
                    class: 'form__item width-130'
                }
            });


        return vm;
    });